module.exports = __webpack_public_path__ + "img/奖品-元气碎片+元石.3d4cc13e.png";